module.exports = __webpack_public_path__ + "static/media/preApproved.5fe98b8a.png";